export default function experienceMarkerSelected(sm, experienceMarker){
    experienceMarker.trackSelected();
    const mapFilter = sm.state['mapFilter'];
    const experience = experienceMarker.experience;
    if (mapFilter && experience) {
        experienceMarker.onlineApp.onlineAppRouter.navigateToFilterExperience(mapFilter, experience);
    }
}